module.exports = __webpack_public_path__ + "img/shadow.9477a21.webp";